import { FC, ReactNode, useState } from 'react'
import { CondicaoCatalogo } from '../../formularios/core/condicao/catalogo'
import { CustomTabs } from '../../../../components/Navigation/CustomTabs'
import { DetailField, DetailFields } from '../../../../components/DetailPanel/DetailPanel'
import { FormularioVinculadoLeitura } from '../detalhe/FormularioVinculadoLeitura'
import { RegrasPorGrupo } from '../detalhe/RegrasPorGrupo'
import { FormularioVinculado, RegraProtocolo } from '../core/_models'

type Aba = 'regras' | 'formulario'

type Props = {
  /** Hash do conteúdo, exibido inteiro numa linha só. */
  hash?: string
  /** Texto quando ainda não há hash (ex.: rascunho). */
  hashAusente?: string
  /** Campos extras abaixo do hash (<DetailField>s), ex.: formato do arquivo. */
  campos?: ReactNode
  regras?: RegraProtocolo[]
  formulario?: FormularioVinculado
  catalogo?: CondicaoCatalogo
  /** Rótulo da aba do formulário (ex.: "Formulário vinculado"). */
  rotuloFormulario?: string
  /** Formulário travado para edição (ex.: vinculado à versão vigente), com o motivo. */
  formularioBloqueado?: boolean
  motivoBloqueioFormulario?: string
}

/**
 * Conteúdo de uma versão (modelo publicado, versão do modelo da plataforma), só leitura: hash e
 * campos de identificação, e as abas de regras e formulário. Regras e formulário são os mesmos
 * componentes do detalhe do protocolo (`RegrasPorGrupo`, `FormularioVinculadoLeitura`).
 */
export const ConteudoVersaoLeitura: FC<Props> = ({
  hash,
  hashAusente,
  campos,
  regras,
  formulario,
  catalogo,
  rotuloFormulario = 'Formulário',
  formularioBloqueado,
  motivoBloqueioFormulario,
}) => {
  const [aba, setAba] = useState<Aba>('regras')

  return (
    <div className='card-body'>
      <div className='d-flex flex-column gap-4 mb-8'>
        {/* Hash inteiro, numa linha só: fica fora do grid de campos (que limita a largura de cada
            coluna) e ocupa a linha toda. Só em tela muito estreita rola na horizontal. */}
        <dl className='m-0 overflow-x-auto'>
          <DetailField
            label='Hash do conteúdo'
            value={hash ? <code className='text-nowrap'>{hash}</code> : undefined}
            emptyLabel={hashAusente}
          />
        </dl>
        {campos && <DetailFields>{campos}</DetailFields>}
      </div>

      <CustomTabs<Aba>
        className='mb-6'
        tabs={[
          { id: 'regras', label: 'Regras' },
          { id: 'formulario', label: rotuloFormulario },
        ]}
        activeTab={aba}
        onChange={setAba}
      />

      {aba === 'regras' ? (
        <RegrasPorGrupo regras={regras} campos={formulario?.campos} catalogo={catalogo} />
      ) : (
        <FormularioVinculadoLeitura
          formulario={formulario}
          catalogo={catalogo}
          bloqueado={formularioBloqueado}
          motivoBloqueio={motivoBloqueioFormulario}
        />
      )}
    </div>
  )
}
